<!--
 * @Date: 2022-05-09 15:26:30
 * @Author: 陶子
 * @LastEditTime: 2022-06-07 15:25:00
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\baseManagement\maintain\myRepair\maintenanceReport.vue
 * @pageName: 这是--(维修汇报)--页面
-->
<template>
  <div class="recordDetail">
    <Navbar appTitle="维修汇报" />
    <!--头部-->
    <div class="d-head">
      <div class="content">
        <div class="left">
          <div class="title">报修编号：{{ detailInfo.repairCode }}</div>
          <div class="row limitRow" style="margin-top: 0.1rem">
            <span class="r-label limitLabel">故障设备：</span>
            <span class="r-column limitColumn"
              >{{ detailInfo.deviceCode || "--" }} |
              {{ detailInfo.deviceName || "--" }}</span
            >
          </div>
          <div class="row limitRow" style="margin-top: 0.1rem">
            <span class="r-label limitLabel">设备类别：</span>
            <span class="r-column limitColumn">{{
              detailInfo.deviceCategoryText || "--"
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="search-content wrap-apply"
      :style="{
        top: GLOBAL.currentEnvironment ? '1.17rem' : '1.62rem',
        height: GLOBAL.currentEnvironment ? '100vh' : 'calc(100vh - 2.22rem)',
        paddingBottom: GLOBAL.currentEnvironment ? '0.66rem' : '',
      }"
    >

      <van-cell-group style="margin: 0.1rem 0">
        <p class="label FormTit"><span></span>故障类别</p>
        <van-field :is-link='buildForm.faultCategoryText?false:true' readonly name="picker" v-model="buildForm.faultCategoryText" @click="categoryVisible = true"
            placeholder="请选择">
            <div slot="right-icon" v-show="!!buildForm.faultCategoryText" @click.stop="cancelCategory"><van-icon name="clear" size="0.16rem" /></div>
          </van-field>
      </van-cell-group>
      <van-cell-group style="margin: 0.1rem 0">
        <p class="label FormTit"><span></span>故障原因</p>
        <van-field
          v-model="buildForm.faultReason"
          rows="2"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          placeholder="请输入"
          show-word-limit
        />
      </van-cell-group>
      <van-cell-group style="margin-top: 0.1rem">
        <p class="label FormTit" style="padding-left:8.89px"><span style="color: red;">*</span>维修描述</p>
        <van-field
          v-model="buildForm.repairDescription"
          rows="2"
          autosize
          label=""
          type="textarea"
          maxlength="500"
          placeholder="请输入"
          show-word-limit
        />
        <div class="bottomLine"></div>
      </van-cell-group>
      <van-cell-group>
        <upload iconType="fj" @fileChange="fileChange" :fileIds="attachment" />
      </van-cell-group>
      <div class="search-bottoms">
        <van-button
          :loading="loadingSub"
          type="info"
          loading-text="提交中..."
          class="btnconfirm"
          @click="handleSubmit()"
          >提交</van-button
        >
      </div>
    </div>
    <van-popup v-model="categoryVisible" position="bottom">
      <van-picker :columns="categoryOptions" @confirm="categoryConfirm" @cancel="categoryVisible = false" show-toolbar />
    </van-popup>
  </div>
</template>

<script>
import Navbar from "@/components/navBar/navBar_right";
import upload from "@/components/upload/upload";
import { getDictModel } from '@/api/system'
import {
  reportNewRepairInfo,
  repairReport
} from "@/api/system";
export default {
  name: "inspectionTaskDetail", //任务详情
  components: { Navbar, upload },
  data() {
    return {
      listIndex: null,
      messDeviceMaintainTaskItem: [{}],
      attachment: "", //附件
      buildForm: {
        repairId: "",
      },
      tabActive: 0,
      detailInfo: {},
      loadingSub: false,
      loginUser: {},
      categoryOptions: [],
      categoryVisible: false
    };
  },
  computed: {},
  mounted() {},
  created() {
    this.buildForm.repairId = this.$route.query.id
    this.detailInfo.repairCode = this.$route.query.repairCode
    this.detailInfo.deviceName = this.$route.query.deviceName
    this.detailInfo.deviceCode = this.$route.query.deviceCode
    this.detailInfo.deviceCategoryText = this.$route.query.deviceCategoryText
    this.loginUser = JSON.parse(localStorage.getItem('pro__Login_Userinfo'))
    this.getDetail();
  },
  methods: {
    categoryConfirm(v) {
      if (!v) {
        this.categoryVisible = false;
        return;
      }
      this.buildForm.faultCategoryText = v.text;
      this.buildForm.faultCategory = v.value;
      this.categoryVisible = false;
    },
    cancelCategory() {
      this.buildForm.faultCategoryText = '';
      this.buildForm.faultCategory = '';
      this.$forceUpdate()
    },
    fileChange(ids) {
      this.attachment = ids;
    },
    goBack() {
      // 跳转到列表页
      //   this.$router.push({
      //     path: "/inspectionTaskList",
      //   });
      this.$router.go(-1);
    },
    handleSubmit() {
      if (!this.buildForm.repairDescription) {
        this.$toast('维修描述必填！')
        return
      } else {
        this.loadingSub = true;
      }
      let params = {
        ...this.buildForm,
        attachment: this.attachment,
      };
      repairReport(params).then((res) => {
        this.loadingSub = false;
        if (res.code == 200) {
          this.$toast("维修汇报成功！");
          this.goBack();
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 获取详情
    getDetail() {
      let obj = {
        repairId: this.buildForm.repairId,
        assignedRepairPersonnel: this.loginUser.value.id,
      }
      reportNewRepairInfo(obj).then((res) => {
        if (res.success) {
          if (res.result) {
            this.buildForm.faultCategory = res.result.faultCategory ? res.result.faultCategory : undefined
            this.buildForm.faultReason = res.result.faultReason
            this.buildForm.repairDescription = res.result.repairDescription
            this.attachment = res.result.attachment
            this.$forceUpdate()
          }
        } else {
          this.$antdMessage.warning(res.message)
        }
      })
      getDictModel({ dictCode: 'mess_fault_category' }).then((res) => {
        if (res.success) {
          this.categoryOptions = res.result
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/views/workManagement/materialRequisition/materialDetail.scss";
@import "@/assets/theme.scss";

.content {
  margin-left: 0 !important;
}
// 盘点物品样式

.left {
  width: 3.4rem !important;
}
.recordDetail {
  position: relative;
}
.tabs-f {
  position: relative;
  top: 1.53rem;
}
.infoTopBox {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.16rem;
  margin-top: 0.1rem;
  .itemTopInfo {
    position: relative;
    margin-top: 0.1rem;
    font-size: 0.14rem;
    color: #888888;
    display: flex;
    &:nth-child(1) {
      margin-top: 0;
    }
    .spanLeft {
      white-space: nowrap;
    }
    .spanRight {
      flex: 1;
      color: #191f25;
      /deep/.filerows2 {
        padding-bottom: 0;
      }
      /deep/.filerows2:nth-of-type(n + 2) {
        padding-top: 0.15rem;
      }
    }
  }
}
div.infoBotBox {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.16rem;
  margin-top: 0.1rem;
  div.remarkBox {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 0.14rem;
    color: #888888;
    display: flex;
    margin-bottom: 0.1rem;
    div.leftRemark {
      width: 0.7rem;
    }

    div.rightRemark {
      flex: 1;
      color: #191f25;
    }
  }
}
.listBox {
  height: calc(100vh - 2.5rem);
  overflow: auto;
}
div.goodBox {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 0.06rem 0;
  img.goodLeft {
    width: 0.55rem;
    height: 0.55rem;
    border-radius: 0.02rem;
  }

  div.goodRight {
    flex: 1;
    margin-left: 0.1rem;
    div.gooodName {
      width: 90%;
      font-size: 0.16rem;
      font-weight: 500;
      color: #191f25;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-bottom: 0.1rem;
    }

    div.gooodCode {
      position: relative;
      margin-bottom: 0.1rem;
      span.codeBefore {
        font-size: 0.14rem;
        color: #888888;
      }

      span.goodAfter {
        display: inline-block;
        font-size: 0.16rem;
        color: #191f25;
      }
    }

    div.goodSpec {
      margin-bottom: 0.1rem;
      span.specBefore {
        font-size: 0.14rem;
        color: #888888;
      }

      span.specAfter {
        font-size: 0.16rem;
        color: #191f25;
      }
    }

    div.numberBox {
      box-sizing: border-box;
      padding: 0.1rem 0;
      border-top: 0.01rem solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div.numTopBox {
        flex: 1;
        div.topTop {
          font-size: 0.14rem;
          color: #888888;
          margin-bottom: 0.1rem;
        }

        div.topBot {
          font-size: 0.16rem;
          color: #191f25;
        }
      }
    }
  }
}
.limitRow {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  .limitColumn {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    // color: #1890ff;
  }
}
/deep/.van-tabs__line {
  width: 67px;
}
.status {
  margin-right: 0.1rem;
}
.icon {
  display: inline-block;
  width: 0.03rem;
  height: 0.14rem;
  background: #1890ff;
  position: absolute;
  left: -0.1rem;
  top: 0.06rem;
}
.listClass {
  padding: 0 0.16rem 0 0.16rem !important ;
}

.search-content {
  //  padding-bottom: 0.5rem;
  position: fixed;
  top: 0.42rem;
  width: 100%;
  height: calc(100vh - 1.12rem);
  background: #f5f5f5;
  overflow: scroll;
  z-index: 99;
  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
}
.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0 0.16rem;
}
.otherText {
  padding-bottom: 0.16rem;
  font-size: 0.16rem;
  font-weight: bold;
  color: #191f25;
}
.haveUnitBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 0.16rem;
  /deep/ .van-cell {
    padding-right: 0;
    width: 2.6rem;
  }
  /deep/ .van-field__control {
    max-width: 3rem;
  }
}
/deep/ .van-nav-bar {
  z-index: 99;
}
.search-bottoms {
  width: 100%;
  height: 0.5rem;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0px;
  padding: 0rem 0.11rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  font-weight: 500;
  z-index: 9;
  .btncancel {
    flex: 1;
    background: #f6f6f6;
    border: 0.01rem solid rgba(25, 31, 37, 0.12);
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    margin-right: 0.11rem;
    color: #191f25;
  }
  .btnconfirm {
    flex: 1;
    background: #1890ff;
    box-sizing: border-box;
    height: 0.39rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.03rem;
    color: #ffffff;
  }
}
.addgoods {
  background: #fff;
  font-size: 0.16rem;
  text-align: center;
  height: 0.5rem;
  line-height: 0.5rem;
}
</style>
